import { createFileRoute, redirect } from "@tanstack/react-router";
import { SettingsPage } from "../../pages/settings/Settings.page";

export const Route = createFileRoute("/_protected/settings")({
  beforeLoad: () => {
    if (import.meta.env.VITE_LOCAL_AUTH !== "true") {
      throw redirect({ to: "/dashboard" });
    }
  },
  component: SettingsPage,
});
